// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__-Sb7K","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2srn4","obliqueLine":"membershipbadge_obliqueLine__3YP-6"};